import React from 'react';
import {Link} from "react-router-dom";
import {withStore} from "../../../hocs";
import {observer} from "mobx-react";
import {ISectionMenuL1, ISectionMenuL2} from "../../../interface/ISection";
import {HelperCatalog} from "../../../helper/HelperCatalog";

// @ts-ignore
@withStore
@observer
export class SectionTopMenu extends React.Component {

    render() {

        // @ts-ignore
        const {store} = this.props;
        const {arSection} = store?.componentCatalogSectionStore;
        const {setPageCatalogL1, setPageCatalogL2, setPageCatalog, openCatalog} = store?.pageCatalogStore;

let Width = window.innerWidth
        return (
            <>
                <div className="sidebar">
                    <div className="catalog-btn" style={Width < 768 ? {width: 110} : {}}>
                        <Link className="catalog__title" onClick={()=>setPageCatalog()} to="/catalog">
                            <img className="catalog-svg" src="/img/ico/catalog.svg" alt="catalog.svg"/>
                            Каталог
                            <img className="arrow-svg" src="/img/ico/arrow-down-white.svg" style={openCatalog ? {transform: 'rotate(180deg)', marginLeft: 15}: {marginRight: -8}} alt="arrow.svg"/>
                        </Link>
                        {arSection.length && openCatalog ?
                            <ul className="menu-catalog-top" style={{width: 170}}>
                                {arSection.map(((lev1: ISectionMenuL1) => (
                                    <li className="menu-catalog-top__item" key={'mtl1' + lev1.id}>
                                        <Link to={HelperCatalog.getUrlList(lev1, null)}  onClick={()=>setPageCatalogL1(lev1)} >
                                            <div className="svg-top-menu"> {lev1.svgSectionTop}</div>
                                            <span>{lev1.name}</span>
                                        </Link>
                                        {lev1.SectionChild.length ? (<ul className="sub-menu-catalog-top" style={{width: 170, left: 170}}>
                                            {lev1.SectionChild.map((lev2: ISectionMenuL2) => (
                                                <li className="sub-menu-catalog-top__item" key={'mtl2' + lev2.id} onClick={()=>setPageCatalogL2(lev1,lev2)}>
                                                    <Link to={HelperCatalog.getUrlList(lev1, lev2)}>
                                                        <span>{lev2.name}</span>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>) : null}
                                    </li>
                                )))}
                            </ul>
                            : null}
                    </div>
                </div>
            </>
        );
    }
}


